import { handleResponseOld, makePost } from './helpers';
import { CatalogRegistration } from '@/types/CatalogRegistration';

/**
 * @category Item API
 * @see postUpcomingCatalogRegistration
 */
type PostUpcomingCatalogRegistrationResponse = {
    data: CatalogRegistration[];
    message: string;
    success: boolean;
};

/**
 * @category Item API
 * @see postUpcomingCatalogRegistration
 */
type PostUpcomingCatalogRegistrationParams = {
    authToken: string;
    catalogId: number;
    deployment: string;
};

/**
 * POST request to item-api service sends catalogIds and returns upcoming catalog registrations
 * @function postUpcomingCatalogRegistration
 * @category Item API
 * @param {PostUpcomingCatalogRegistrationParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/catalog/registration
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/bidder/routes/post-catalog-registration-by-catalogIds.ts
 */
export const postUpcomingCatalogRegistration = ({
    authToken,
    catalogId,
    deployment,
}: PostUpcomingCatalogRegistrationParams) =>
    new Promise<PostUpcomingCatalogRegistrationResponse>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: '<ITEM-API>catalog/registration',
        });
        request.send({
            catalogIds: [catalogId],
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
